import React, { useState } from 'react';
import { Input } from 'antd';
import 'components/editable-section-title/editable-section-title.scss';

export interface EditableSectionTitleProps {
    value: string;
    onSave: (newValue: string) => void;
}

const EditableSectionTitle: React.FC<EditableSectionTitleProps> = (props) => {
    const [isEditing, setIsEditing] = useState(false);
    const [draftValue, setDraftValue] = useState(props.value);

    const startEditing = () => {
        setDraftValue(props.value);
        setIsEditing(true);
    };

    const commit = () => {
        setIsEditing(false);
        const trimmedValue = draftValue.trim();
        if (trimmedValue && trimmedValue !== props.value) {
            props.onSave(trimmedValue);
        }
    };

    const cancel = () => {
        setDraftValue(props.value);
        setIsEditing(false);
    };

    if (isEditing) {
        return (
            <Input
                className={'editable-section-title-input'}
                autoFocus
                size={'small'}
                value={draftValue}
                onChange={(event) => setDraftValue(event.target.value)}
                onBlur={commit}
                onPressEnter={commit}
                onKeyDown={(event) => {
                    if (event.key === 'Escape') cancel();
                }}
            />
        );
    }

    return (
        <span className={'editable-section-title'} onClick={startEditing}>
            {props.value}
        </span>
    );
};

export default EditableSectionTitle;
